module.exports = "/_next/static/images/python-logo-6401253bd8ab40099ff3265922b4e947.png";